// Minimal theme JS placeholder – extend as needed.
document.documentElement.classList.add('kaido-loaded');
// Hard-kill any visible "KAIDO LINEUP" labels on the page
document.addEventListener('DOMContentLoaded', function () {
  var allElements = document.querySelectorAll('body *');
  allElements.forEach(function (el) {
    if (!el.children.length && el.textContent) {
      var text = el.textContent.trim().toUpperCase();
      if (text === 'KAIDO LINEUP') {
        el.style.display = 'none';
      }
    }
  });
});
// Auto-submit cart form when quantity changes
document.addEventListener('change', function (event) {
  var input = event.target;
  if (
    input.tagName === 'INPUT' &&
    input.type === 'number' &&
    input.name &&
    input.name.indexOf('updates[') === 0
  ) {
    if (input.form) {
      input.form.submit();
    }
  }
});
